import { gql } from "urql";
export const GetOrganizationCountQuery = gql `
    query GetOrganizationCount($search: String) {
        organizations {
            organizationCount(search: $search)
        }
    }
`;
export const GetOrganizationsQuery = gql `
    query GetOrganizations($search: String, $offset: Int) {
        organizations {
            organizations(search: $search, offset: $offset) {
                organizationId
                npiNumber
                name
                email
                phoneNumber
                organizationTypes
                imageUrl
                isActive
            }
        }
    }
`;
export const GetOrganizationDetailsQuery = gql `
    query GetOrganizationDetails($organizationId: String!) {
        organizations {
            organization(organizationId: $organizationId) {
                organizationId
                name
                npiNumber
                email
                phoneNumber
                organizationTypes
                websiteUrl
                about
                notes
                imageUrl
                isActive
                createdAt
                insuranceList {
                    value
                    label
                }
                therapyCategoryList {
                    value
                    label
                }
            }
        }
    }
`;
export const GetOrganizationListQuery = gql `
    query GetOrganizationList {
        organizations {
            organizationList {
                value
                label
                imageUrl
            }
        }
    }
`;
export const GetOrganizationDashboardQuery = gql `
    query GetOrganizationDashboard($startDate: String, $endDate: String) {
        organizations {
            organizationDashboard(startDate: $startDate, endDate: $endDate) {
                referralPipelineCount
                pipelineReferralsWithoutAssignedProviderCount
                inboundTriageCount
                directReferralCount
                directReferralsReceivedCount
                websiteLeadCount
                websiteLeadsMovedToPipelineCount
                globalReferralInvitePendingCount
                staleReferralPipelineCount
                pendingInviteCount
            }
        }
    }
`;
